module.exports = __webpack_public_path__ + "img/1.85bf59f0.jpg";